import { render, staticRenderFns } from "./ProductsInformation.vue?vue&type=template&id=605c4ae7&scoped=true&"
import script from "./ProductsInformation.vue?vue&type=script&lang=js&"
export * from "./ProductsInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInformation.vue?vue&type=style&index=0&id=605c4ae7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605c4ae7",
  null
  
)

component.options.__file = "ProductsInformation.vue"
export default component.exports